import { createAction, props } from '@ngrx/store';
import {
  OrganizationChannel,
  ConfiguredChannel,
  DistributionList,
  Template,
  EverbridgeTemplate,
  MassNotificationTemplate,
  MassNotificationTemplateGroup,
  MassNotification,
  ToRecipientSettings,
  MassNotificationRecipient,
  MassNotificationStats,
  WhatsAppTemplate,
  DefaultConfiguredChannelSettings
} from './communications.model';
import {
  DocumentQueryParams,
  Filter,
  FilterGroup,
  FilterGroupType,
  QueryParams,
  RuleOperator,
  QueryResult,
  Workflow
} from 'src/app/modules/core/store/models';
import { Document } from 'src/app/modules/core/store/models/document.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

//
// OrganizationChannel actions
//
export const getOrganizationChannelsFromApi = createAction('[Comms/Channel/API] Get Organization Channels');
export const getOrganizationChannelsFromApiComplete = createAction(
  '[Comms/Channel/API] Get Organization Channels Complete',
  props<{ data: QueryResult<OrganizationChannel> }>()
);
export const newTopoEmailChannel = createAction('[Comms/Channel/Page] New Topo Email Channel', props<{ channel: OrganizationChannel }>());
export const newSendGridEmailChannel = createAction(
  '[Comms/Channel/Page] New SendGrid Email Channel',
  props<{ channel: OrganizationChannel }>()
);
export const newTwilioChannel = createAction('[Comms/Channel/Page] New Twilio Channel', props<{ channel: OrganizationChannel }>());
export const newTwilioTtsChannel = createAction('[Comms/Channel/Page] New Twilio TTS Channel', props<{ channel: OrganizationChannel }>());
export const newWhatsAppChannel = createAction('[Comms/Channel/Page] New WhatsApp Channel', props<{ channel: OrganizationChannel }>());
export const newSlackChannel = createAction('[Comms/Channel/Page] New Slack Channel', props<{ channel: OrganizationChannel }>());
export const newTeamsChannel = createAction('[Comms/Channel/Page] New Teams Channel', props<{ channel: OrganizationChannel }>());
export const newRegroupChannel = createAction('[Comms/Channel/Page] New Regroup Channel', props<{ channel: OrganizationChannel }>());
export const newOnSolveChannel = createAction('[Comms/Channel/Page] New OnSolve Channel', props<{ channel: OrganizationChannel }>());
export const newAlertMediaChannel = createAction('[Comms/Channel/Page] New AlertMedia Channel', props<{ channel: OrganizationChannel }>());
export const newEverbridgeChannel = createAction('[Comms/Channel/Page] New Everbridge Channel', props<{ channel: OrganizationChannel }>());
export const newHorizonSmsChannel = createAction('[Comms/Channel/Page] New Horizon Sms Channel', props<{ channel: OrganizationChannel }>());
export const newHorizonMobilePushChannel = createAction(
  '[Comms/Channel/Page] New Horizon Mobile Push Channel',
  props<{ channel: OrganizationChannel }>()
);
export const newGwtsMobileChannel = createAction(
  '[Comms/Channel/Page] New GWTS Mobile Channel',
  props<{ channel: OrganizationChannel }>()
);

//
// ConfiguredChannel actions
//
export const getConfiguredChannelsFromApi = createAction(
  '[Comms/Channel/API] Get Configured Channels',
  props<{ queryParams: QueryParams }>()
);
export const getConfiguredChannelsFromApiComplete = createAction(
  '[Comms/Channel/API] Get Configured Channels Complete',
  props<{ data: QueryResult<ConfiguredChannel> }>()
);
export const saveConfiguredChannelToApi = createAction(
  '[Comms/Channel/API] Save Configured Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const saveConfiguredChannelToApiComplete = createAction(
  '[Comms/Channel/API] Save Configured Channel Complete',
  props<{ channelUId: string }>()
);
export const saveAndConnectToSlack = createAction('[Comms/Channel/API] Save and Connect to Slack', props<{ channel: ConfiguredChannel }>());
export const updateSelectedConfiguredChannel = createAction(
  '[Comms/Channel/API] Update Configured Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const connectToSlack = createAction('[Comms/Channel/API] Connect to Slack', props<{ channel: ConfiguredChannel }>());
export const deleteConfiguredChannelApi = createAction(
  '[Comms/Channel/API] Delete Configured Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const deleteConfiguredChannelApiComplete = createAction('[Comms/Channel/API] Delete Configured Channel Complete');
export const displayChannelError = createAction('[Comms/Channel/Page] Display Error', props<{ err: any }>());
export const closeConfiguredChannelEdit = createAction('[Comms/Channel/Page] Close Configured Channel Edit');
export const editTopoEmailChannel = createAction('[Comms/Channel/Page] Edit Topo Email Channel', props<{ channel: ConfiguredChannel }>());
export const editSendGridEmailChannel = createAction(
  '[Comms/Channel/Page] Edit SendGrid Email Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const editEverbridgeChannel = createAction('[Comms/Channel/Page] Edit Everbridge Channel', props<{ channel: ConfiguredChannel }>());
export const editSlackChannel = createAction('[Comms/Channel/Page] Edit Slack Channel', props<{ channel: ConfiguredChannel }>());
export const editMicrosoftTeamsChannel = createAction(
  '[Comms/Channel/Page] Edit Microsoft Teams Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const setChannelToDelete = createAction('[Comms/Channel/Page] Set Channel to Delete', props<{ channel: ConfiguredChannel }>());
export const clearChannelToDelete = createAction('[Comms/Channel/Page] Clear Channel to Delete');
export const startGetSlackChannels = createAction('[Comms/Channel/Page] Start Get Slack Channels');
export const getSlackChannelsForConfiguredChannelFromApi = createAction(
  '[Comms/Channel/API] Get Slack Channels For ConfiguredChannel',
  props<{ channel: ConfiguredChannel }>()
);
export const getSlackChannelsForConfiguredChannelFromApiComplete = createAction(
  '[Comms/Channel/API] Get Slack Channels For ConfiguredChannel Complete',
  props<{ channels: any[] }>()
);
export const editTwilioChannel = createAction('[Comms/Channel/Page] Edit Twilio Channel', props<{ channel: ConfiguredChannel }>());
export const editTwilioTtsChannel = createAction('[Comms/Channel/Page] Edit Twilio TTS Channel', props<{ channel: ConfiguredChannel }>());
export const editWhatsAppChannel = createAction('[Comms/Channel/Page] Edit WhatsApp Channel', props<{ channel: ConfiguredChannel }>());
export const editHorizonSmsChannel = createAction('[Comms/Channel/Page] Edit Horizon Sms Channel', props<{ channel: ConfiguredChannel }>());
export const editHorizonMobilePushChannel = createAction(
  '[Comms/Channel/Page] Edit Horizon Mobile Push Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const editGwtsMobileChannel = createAction(
  '[Comms/Channel/Page] Edit GWTS Mobile Channel',
  props<{ channel: ConfiguredChannel }>()
);

export const disconnectFromSlackWithApi = createAction(
  '[Comms/Channel/API] Disconnect Channel From Slack',
  props<{ channel: ConfiguredChannel }>()
);
export const disconnectFromSlackWithApiComplete = createAction(
  '[Comms/Channel/API] Disconnect Channel From Slack Complete',
  props<{ channel: ConfiguredChannel }>()
);

export const syncChannelMembersWithApi = createAction('[Comms/Channel/API] Sync Channel Memebers', props<{ channelUId: string }>());

export const clearSelectedConfiguredChannel = createAction('[Comms/Channel/Page] Clear Selected Configured Channel');

//
// Distribution Lists
//
export const getDistributionListsFromApi = createAction(
  '[Comms/DistributionList/API] Get Distribution Lists',
  props<{ queryParams: QueryParams }>()
);
export const getDistributionListsFromApiComplete = createAction(
  '[Comms/DistributionList/API] Get Distribution Lists Complete',
  props<{ data: QueryResult<DistributionList> }>()
);
export const displayDistributionListError = createAction('[Comms/DistributionList/Page] Display Error', props<{ err: any }>());
export const newDistributionList = createAction('[Comms/DistributionList/Page] New Distribution List');
export const newDistributionListComplete = createAction(
  '[Comms/DistributionList/Page] New Distribution List Complete',
  props<{ distributionList: DistributionList }>()
);
export const cancelNewDistributionList = createAction('[Comms/DistributionList/Page] Cancel New Distribution List');
export const editDistributionList = createAction(
  '[Comms/DistributionList/Page] Edit Distribution List',
  props<{ distributionList: DistributionList }>()
);
export const cancelEditDistributionList = createAction('[Comms/DistributionList/Page] Cancel Edit Distribution List');
export const cancelEditDistributionListComplete = createAction('[Comms/DistributionList/Page] Cancel Edit Distribution List Complete');
export const editDistributionListComplete = createAction(
  '[Comms/DistributionList/Page] Edit Distribution List Complete',
  props<{ distributionList: DistributionList }>()
);
export const setDistributionListToDelete = createAction(
  '[Comms/DistributionList/Page] Set Distribution List To Delete',
  props<{ distributionList: DistributionList }>()
);
export const clearDistributionListToDelete = createAction('[Comms/DistributionList/Page] Clear Distribution List To Delete');
export const deleteDistributionListApi = createAction(
  '[Comms/DistributionList/API] Delete Distribution List Api',
  props<{ distributionList: DistributionList }>()
);
export const deleteDistributionListApiComplete = createAction('[Comms/DistributionList/API] Delete Distribution List Api Complete');
export const saveDistributionListToApi = createAction(
  '[Comms/DistributionList/API] Save Distribution List to Api',
  props<{ distributionList: DistributionList }>()
);
export const saveDistributionListToApiComplete = createAction(
  '[Comms/DistributionList/API] Save Distribution List to Api Complete',
  props<{ distributionList: DistributionList }>()
);
export const getDocumentsWithFilterFromApi = createAction(
  '[Comms/DistributionList/API] Get Documents With Filter',
  props<{ datasetUId: string; queryParams: QueryParams; filter: FilterGroup }>()
);
export const getDocumentsWithFilterFromApiComplete = createAction(
  '[Comms/DistributionList/API] Get Documents With Filter Complete',
  props<{ results: QueryResult<Document> }>()
);
export const saveDocument = createAction(
  '[Comms/DistributionList/Page] Save Document',
  props<{ document: Document; dataset: Dataset; filter: FilterGroup; isNewDocument: boolean }>()
);

//
// Distribution Lists
//
export const getDatasetFromApi = createAction('[Comms/CommunicationCenter/API] Get Dataset from API', props<{ datasetUId: string }>());
export const getDatasetFromApiComplete = createAction(
  '[Comms/CommunicationCenter/API] Get Dataset from API Complete',
  props<{ dataset: Dataset }>()
);

//
// Distribution Lists
//
export const getTemplatesFromApi = createAction('[Comms/Templates/API] Get Templates', props<{ queryParams: QueryParams }>());
export const getTemplatesFromApiComplete = createAction(
  '[Comms/Templates/API] Get Templates Complete',
  props<{ data: QueryResult<Template> }>()
);
export const getEverbridgeTemplatesFromApi = createAction(
  '[Comms/Templates/API] Get Everbridge Templates',
  props<{ channel: ConfiguredChannel }>()
);
export const getEverbridgeTemplatesFromApiComplete = createAction(
  '[Comms/Templates/API] Get Everbridge Templates Complete',
  props<{ templates: EverbridgeTemplate[] }>()
);

//
// Templates
//
export const newTemplate = createAction('[Comms/Template/Page] New Template');
export const newTemplateComplete = createAction('[Comms/Template/Page] New Template Complete', props<{ template: Template }>());
export const cancelNewTemplate = createAction('[Comms/Template/Page] Cancel New Template');
export const editTemplate = createAction('[Comms/Template/Page] Edit Template', props<{ template: Template }>());
export const cancelEditTemplate = createAction('[Comms/Template/Page] Cancel Edit Template');
export const cancelEditTemplateComplete = createAction('[Comms/Template/Page] Cancel Edit Template Complete');
export const editTemplateComplete = createAction('[Comms/Template/Page] Edit Template Complete', props<{ template: Template }>());
export const setTemplateToDelete = createAction('[Comms/Template/Page] Set Template To Delete', props<{ template: Template }>());
export const clearTemplateToDelete = createAction('[Comms/Template/Page] Clear Template To Delete');
export const deleteTemplateApi = createAction('[Comms/Template/API] Delete Template Api', props<{ template: Template }>());
export const deleteTemplateApiComplete = createAction('[Comms/Template/API] Delete Template Api Complete');
export const saveTemplateToApi = createAction(
  '[Comms/Template/API] Save Template List to Api',
  props<{ template: Template; skipNavigation?: boolean }>()
);
export const saveTemplateToApiComplete = createAction(
  '[Comms/Template/API] Save Template to Api Complete',
  props<{ template: Template }>()
);
export const setTemplateToCopy = createAction('[Comms/Template/Page] Set Template To Copy', props<{ template: Template }>());
export const clearTemplateToCopy = createAction('[Comms/Template/Page] Clear Template To Copy');
export const copyTemplate = createAction('[Comms/Template/API] Copy Template', props<{ template: Template }>());
export const getDefaultConfiguredChannelFromApi = createAction('[Comms/Channel] Get Default Configured Channel From API');
export const getDefaultConfiguredChannelComplete = createAction('[Comms/Channel] Get Default Configured Channel Complete',
  props<{ settings: DefaultConfiguredChannelSettings }>()
);

//
// MassNotification Templates
//
export const newMassNotificationTemplate = createAction('[MassNotificationTemplate] New Template');
export const editMassNotificationTemplate = createAction(
  '[MassNotificationTemplate] Edit Template',
  props<{ template: MassNotificationTemplate }>()
);
export const copyMassNotificationTemplate = createAction(
  '[MassNotificationTemplate] Copy Template',
  props<{ template: MassNotificationTemplate }>()
);
export const deleteMassNotificationTemplate = createAction(
  '[MassNotificationTemplate] Delete MassNotificationTemplate',
  props<{ template: MassNotificationTemplate }>()
);
export const setMassNotificationTemplateActive = createAction(
  '[MassNotificationTemplate] Set Template Active',
  props<{ active: boolean; template: MassNotificationTemplate }>()
);
export const setSelectedMassNotificationTemplate = createAction(
  '[MassNotificationTemplate] Set Selected Template',
  props<{ template: MassNotificationTemplate; isDirty: boolean }>()
);
export const setMassNotificationTemplatesTableChanged = createAction(
  '[MassNotificationTemplate] Set Table Changed',
  props<{ changed: boolean }>()
);
export const setMassNotificationTemplatesIsDirty = createAction('[MassNotificationTemplate] Set Is Dirty', props<{ isDirty: boolean }>());

export const saveSelectedMassNotificationTemplate = createAction(
  '[MassNotificationTemplate/API] Save Selected Mass Template',
  props<{ close: boolean; template: MassNotificationTemplate }>()
);
export const updateMassNotificationTemplate = createAction(
  '[MassNotificationTemplate/API] Update Mass Template',
  props<{ template: MassNotificationTemplate; close: boolean }>()
);
export const createMassNotificationTemplate = createAction(
  '[MassNotificationTemplate/API] Create Mass Template',
  props<{ template: MassNotificationTemplate; close: boolean }>()
);
export const updateMassNotificationTemplateComplete = createAction(
  '[MassNotificationTemplate/API] Update Mass Template Complete',
  props<{ template: MassNotificationTemplate }>()
);
export const getWhatsAppTemplatesFromApi = createAction(
  '[MassNotificationTemplate/API] Get WhatsApp Templates From Api',
  props<{ cultureCode: string }>()
);
export const getWhatsAppTemplatesFromApiComplete = createAction(
  '[MassNotificationTemplate/API] Get WhatsApp Templates From Api Complete',
  props<{ results: WhatsAppTemplate[] }>()
);
export const getWhatsAppTemplateGroupFromApi = createAction(
  '[MassNotificationTemplate/API] Get WhatsApp Template Group From Api',
  props<{ templateGroupUId: string }>()
);
export const getWhatsAppTemplateGroupFromApiComplete = createAction(
  '[MassNotificationTemplate/API] Get WhatsApp Template Group From Api Complete',
  props<{ results: WhatsAppTemplate[] }>()
);


//
// MassNotification Template Groups
//
export const newMassNotificationTemplateGroup = createAction('[MassNotificationTemplateGroup] New Template Group');
export const editMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup] Edit Template Group',
  props<{ templateGroup: MassNotificationTemplateGroup }>()
);
export const copyMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup] Copy Template Group',
  props<{ templateGroup: MassNotificationTemplateGroup }>()
);
export const deleteMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup] Delete MassNotificationTemplateGroup',
  props<{ templateGroup: MassNotificationTemplateGroup }>()
);
export const setSelectedMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup] Set Selected Template Group',
  props<{ templateGroup: MassNotificationTemplateGroup; isDirty: boolean }>()
);
export const setMassNotificationTemplateGroupsTableChanged = createAction(
  '[MassNotificationTemplateGroup] Set Table Changed',
  props<{ changed: boolean }>()
);
export const setMassNotificationTemplateGroupsIsDirty = createAction('[MassNotificationTemplateGroup] Set Is Dirty', props<{ isDirty: boolean }>());

export const saveSelectedMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup/API] Save Selected Mass Template Group',
  props<{ close: boolean }>()
);
export const updateMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup/API] Update Mass Template Group',
  props<{ templateGroup: MassNotificationTemplateGroup; close: boolean }>()
);
export const createMassNotificationTemplateGroup = createAction(
  '[MassNotificationTemplateGroup/API] Create Mass Template Group',
  props<{ templateGroup: MassNotificationTemplateGroup; close: boolean }>()
);
export const hasMassNotificationTemplateGroups = createAction(
  '[MassNotificationTemplateGroup/API] Has Mass Template Groups'
);

//
// Mass Notifications
//
export const newMassNotification = createAction('[Comms/Notification/Page] New Notification');
export const reviewMassNotification = createAction(
  '[Comms/Notification/Page] Review Notification',
  props<{ notification: MassNotification }>()
);

export const editMassNotification = createAction(
  '[Comms/Notification/Page] Edit Notification',
  props<{ notification: MassNotification }>()
);
export const deleteMassNotification = createAction(
  '[Comms/Notification/Page] Delete Notification',
  props<{ notification: MassNotification }>()
);
export const showMassNotificationLog = createAction(
  '[Comms/Notification/Page] Notification Log',
  props<{ notification: MassNotification }>()
);
export const setSelectedMassNotification = createAction(
  '[Comms/Notification/Page] Set Selected Notification',
  props<{ notification: MassNotification; isDirty: boolean }>()
);
export const setMassNotificationsTableChanged = createAction('[Comms/Notification/Page] Set Table Changed', props<{ changed: boolean }>());
export const setMassNotificationIsDirty = createAction('[Comms/Notification/Page] Set Is Dirty', props<{ isDirty: boolean }>());
export const setMassNotificationIsEditing = createAction('[Comms/Notification/Page] Set Is Editing', props<{ isEditing: boolean }>());

export const saveSelectedMassNotification = createAction(
  '[Comms/Notification/Page/API] Save Selected Mass',
  props<{ close: boolean; monitor: boolean; successMessage?: string }>()
);

export const getRecipeintsDetails = createAction(
  '[Comms/Notification/API] Get Recipients Details',
  props<{ recipientSettings: ToRecipientSettings }>()
);
export const updateMassNotification = createAction(
  '[Comms/Notification/Page/API] Update Mass',
  props<{ notification: MassNotification; close: boolean; successMessage?: string }>()
);
export const createMassNotification = createAction(
  '[Comms/Notification/Page/API] Create Mass',
  props<{ notification: MassNotification; close: boolean; monitor: boolean; successMessage?: string }>()
);
export const updateMassNotificationComplete = createAction(
  '[Comms/Notification/Page/API] Update Mass Complete',
  props<{ notification: MassNotification }>()
);

export const updateMassNotificationRecipient = createAction(
  '[Comms/Notification/Page/API] Update Mass Recipient',
  props<{ recipient: MassNotificationRecipient; close: boolean }>()
);

export const setSelectedMassNotificationRecipient = createAction(
  '[Comms/Notification/Page] Set Selected Notification Recipient',
  props<{ recipient: MassNotificationRecipient; isDirty: boolean }>()
);

export const transitionRecipientsToWorkflowStep = createAction(
  '[Comms/Notification/Page] Transition Selected Notification Recipients To Workflow step',
  props<{ recipientUIds: string[]; targetStepUId: string }>()
);

export const setMassNotificationRecipientsTableChanged = createAction(
  '[Comms/Notification/Page] Set Recipients Table Changed',
  props<{ changed: boolean }>()
);

export const setMassNotificationStatsUpdated = createAction(
  '[Comms/Notification/Worker] Set Mass Notification Stats Updated',
  props<{ stats: MassNotificationStats }>()
);

export const loadDatasetsForSelect = createAction('[Comms/Dataset/API] Load Datasets For Select', props<{ includeWorkflow?: boolean }>());
export const loadDatasetsForSelectComplete = createAction(
  '[Comms/Dataset/API] Load Datasets For Select Complete',
  props<{ results: QueryResult<Dataset> }>()
);
export const setError = createAction('[Comms/Dataset/API] Set Error', props<{ err: any }>());
